var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section section--contact"},[_c('div',{staticClass:"container"},[_c('app-heading',{attrs:{"title":"Contact Agent","tag":"h2"}}),_c('app-contact')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }